// Auraana — interacciones propias (vanilla JS, sin librerias externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initMenuIcons();
  initTilt();
});

function initTilt() {
  var els = document.querySelectorAll('.au-tilt');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var MAX_DEG = 10;

  els.forEach(function (el) {
    var img = el.querySelector('.au-tilt__img');
    if (!img) return;

    function applyTilt(clientX, clientY) {
      var rect = el.getBoundingClientRect();
      var x = (clientX - rect.left) / rect.width;
      var y = (clientY - rect.top) / rect.height;
      var rotateY = (x - 0.5) * MAX_DEG * 2;
      var rotateX = (0.5 - y) * MAX_DEG * 2;
      img.style.transform = 'rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';
    }

    function reset() {
      el.classList.remove('au-tilt--active');
      img.style.transform = 'rotateX(0deg) rotateY(0deg)';
    }

    el.addEventListener('mouseenter', function () { el.classList.add('au-tilt--active'); });
    el.addEventListener('mousemove', function (e) { applyTilt(e.clientX, e.clientY); });
    el.addEventListener('mouseleave', reset);

    el.addEventListener('touchstart', function () { el.classList.add('au-tilt--active'); }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      applyTilt(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    el.addEventListener('touchend', reset);
  });
}

function initMenuIcons() {
  var links = document.querySelectorAll('.au-nav a');
  if (!links.length) return;
  var icons = {
    home: '<svg viewBox="0 0 24 24" fill="none" width="16" height="16" aria-hidden="true"><path d="M4 11.5 12 4l8 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 10v9a1 1 0 0 0 1 1h4v-6h2v6h4a1 1 0 0 0 1-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    shop: '<svg viewBox="0 0 24 24" fill="none" width="16" height="16" aria-hidden="true"><path d="M4 9V5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5V9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 9h16l-1 10.5a1 1 0 0 1-1 .9H6a1 1 0 0 1-1-.9L4 9Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 12.5a3 3 0 0 0 6 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    contact: '<svg viewBox="0 0 24 24" fill="none" width="16" height="16" aria-hidden="true"><path d="M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5v-11Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="m5 7 7 5.5L19 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  links.forEach(function (link) {
    if (link.querySelector('.au-menu-icon')) return;
    var text = link.textContent.trim().toLowerCase();
    var key = null;
    if (text === 'home' || text === 'inicio') key = 'home';
    else if (text === 'shop' || text === 'catalog' || text === 'catálogo' || text === 'catalogo') key = 'shop';
    else if (text === 'contact' || text === 'contacto') key = 'contact';
    if (!key) return;
    var span = document.createElement('span');
    span.className = 'au-menu-icon';
    span.innerHTML = icons[key];
    span.style.cssText = 'display:inline-flex;margin-right:6px;vertical-align:-2px;color:var(--au-color-acento-oscuro, #7D5C79);';
    link.insertBefore(span, link.firstChild);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.au-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('au-visible'); });
    return;
  }
  // threshold 0: basta con que asome un píxel.
  // Con 0.15 los bloques muy altos (la columna de compra en móvil) nunca
  // llegaban al umbral y se quedaban invisibles para siempre.
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('au-visible');
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'none';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: pase lo que pase, a los 2 s todo visible.
  // Se escribe el estilo en línea, no solo la clase: si la transición CSS
  // no llega a ejecutarse (móviles con ahorro de batería, pestañas en
  // segundo plano, motores que no componen frames), la clase sola deja el
  // elemento en opacidad 0 para siempre. Nada de la tienda puede quedarse
  // invisible por culpa de una animación.
  function mostrarTodo() {
    els.forEach(function (el) {
      el.classList.add('au-visible');
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  setTimeout(mostrarTodo, 2000);

  // CRÍTICO para el tráfico de redes sociales.
  // TikTok, Instagram y Facebook abren los enlaces en su navegador interno y
  // la página suele cargar con visibilityState = "hidden". En ese estado el
  // navegador congela los temporizadores, las transiciones CSS y el
  // IntersectionObserver: el contenido se queda en opacidad 0 y el usuario ve
  // la página en blanco. Al pasar a visible, se muestra todo de inmediato.
  if (document.visibilityState === 'hidden') {
    document.addEventListener('visibilitychange', function alVerse() {
      if (document.visibilityState === 'visible') {
        mostrarTodo();
        document.removeEventListener('visibilitychange', alVerse);
      }
    });
  }
}

function initContadores() {
  var els = document.querySelectorAll('.au-count[data-target]');
  if (!els.length) return;
  var animated = new WeakSet();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !animated.has(entry.target)) {
        animated.add(entry.target);
        animarContador(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function animarContador(el) {
  var target = parseFloat(el.getAttribute('data-target'));
  var suffix = el.getAttribute('data-suffix') || '';
  var duration = 1400;
  var start = null;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = target + suffix;
    return;
  }
  function step(ts) {
    if (!start) start = ts;
    var progress = Math.min((ts - start) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var value = Math.round(target * eased * 10) / 10;
    el.textContent = value + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
